// src/app/formdata-upload/base64-upload.component.ts

import { AfterContentChecked, AfterContentInit, Component, ContentChild, ElementRef, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { MatSnackBar } from '@angular/material';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { Observable } from 'rxjs/Observable';


declare var $:any;

@Component({
	selector: 'cargueFacturas',
	templateUrl: './CargueFacturas.component.html'
})
export class CargueFacturasComponent implements AfterContentInit{
	
	public loading: boolean = false;
	public bloquearBoton:boolean = true;
	public mensajes:Array<string> = new Array();
	public displayedColumns;
	public dataSource;
	public erroresTemp:Array<string> = new Array();

	public ocultar: boolean= false;
	public mensaje: string="";

	@ViewChild('fileInput') fileInput: ElementRef;
	@ViewChild('form') form;

	constructor( private _serviciosGenerales:ServiciosGenerales, public snackBar: MatSnackBar) {
		this.displayedColumns = ['mensaje'];
		this.dataSource = new ExampleDataSource(null);
		this.snackBar.dismiss();
	}

	private formulario:any;


	ngAfterContentInit() {
		$('#archivoLoad').on("change", function(){ 
			
			$('#uploadFile').val(
				$('#archivoLoad').val().replace('C:\\fakepath\\', '')
				); 
		});
	}

	onFileChange(event) {
		let reader = new FileReader();
		if(event.target.files && event.target.files.length > 0) {
			let file = event.target.files[0];
			reader.readAsDataURL(file);
			reader.onload = () => {
				this.bloquearBoton = false;
				console.log('Recarga');
				this.formulario ={
					nombreArchivo: file.name,
					//filetype: file.type,
					infoArchivo: reader.result.split(',')[1]
				}
			};
		}
	}

	onSubmit() {

		
		const formModel = this.formulario;
		this.loading = true;
		this.dataSource = new ExampleDataSource(null);
		this.erroresTemp = new Array();

		
		if(formModel == undefined || formModel.infoArchivo == undefined || formModel.infoArchivo == ''){
			this.openSnackBarEspecial("Hay que seleccionar un archivo", "X");
			this.loading = false;
			return;	
		}



		setTimeout( () => { 
		this._serviciosGenerales.get('validacionNombreArchivo', { vnomfile: this.formulario.nombreArchivo }).subscribe(
			result => {
					if(result[0].C == 0){
						var ntipoempresa = JSON.parse(this._serviciosGenerales.seguridad.getInfoToken().ntipoempresa).ntipoempresa 

						var parametros = "{ procedimientoAntes: '-', procedimientoDespues: 'VALIDACIONES_CARGUE_MASIVO_FACTURAS', tablaCargue: 'MchCargueFacturasMasivasTemporal', tablaCargueArchivo: 'MchNombresArchivosCargueFacturas',parametrosProcDespues:{NTIPOEMPRESA:"+ntipoempresa+"}}";
				
						this._serviciosGenerales.post('cargueGenerico/'+parametros, formModel).subscribe(
							result=>{
								this.formulario ={}
								console.log(result);
								$("#archivoLoad").val(null);
								$("#uploadFile").val('');
				
								if(result.error == true){
									if(result.mensajes != undefined){
				
										for(let x in result.mensajes){
											this.erroresTemp.push(result.mensajes[x].mensaje)
										}
										this.dataSource = new ExampleDataSource(this.erroresTemp);
									}if(result.errores){
										for(let x in result.errores){
											this.erroresTemp.push(result.errores[x])
										}
										this.dataSource = new ExampleDataSource(this.erroresTemp);
									}else{
										if(this.erroresTemp.length<=0){
											this.openSnackBar(result.mensaje, "X");
										}
									}
								}else{
									if(result.mensaje.indexOf('FACTURA ELECTRONICA') > -1){
										result.mensaje = result.mensaje.replace('FACTURA ELECTRONICA', '').replace('OK','');
									}else{
										//this._serviciosGenerales.descargarArchivo("generarPdfCargueMasivoFacturas/"+result.cid+'', null);
									}
									this.openSnackBar("Facturas Cargadas correctamente,"+result.mensaje, "X");
								}
								this.loading = false;
				
							},error=>{
								var errorMensaje = <any>error;
								console.log('Error al enviar la peticion ', errorMensaje);
								this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este cargue", "X");
								this.loading = false;
								$("#archivoLoad").val(null);
							})
					}
					else{
						this.openSnackBar("El nombre del archivo"+this.formulario.nombreArchivo +" ya se encuentra registrado en el sistema o se esta procesando.","X");
						this.loading = false;
						}

			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
			});
		}, 1000 );






	
		
	}


	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			
		});
	}
	openSnackBarEspecial(message: string, action: string) {
        let snackBarRef =  this.snackBar.open(message, action);
 
        snackBarRef.onAction().subscribe(() => {
           
            this.ocultar = false;
            this.mensaje = "";
        });
        
        let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;        
        
        if (shand.length != 0) {
                for (let i=0;i<shand.length;i++){
                shand[i].style.backgroundColor = "rgb(255 204 214)";
                }
            }
    }
}



export class ExampleDataSource {

	public data: Array<string>;


	constructor(sucursal:Array<string>){
		this.data = new Array();


		if(sucursal != null){
			for(let i of sucursal){
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<string[]>
	{
		return Observable.of(this.data);
	}

	disconnect()
	{
	}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueFacturasMasivos/CargueFacturas.component.ts